import { HallFloorActionTypes, HallFloorState } from "./types";
import { Reducer } from "redux";

const initialState: HallFloorState = {
  loading: false,
  error: null,
  isHallFloorSubmitting: false,
  isHallFloorDeleting: false,
  success: false,
  failure: false,
  deleteSuccess: false,
  page: "",
  floors: [],
  rooms: [],
  isRoomSubmitting: false,
  isRoomDeleting: false,
  hall: null,
  floor: null,
  room: null,
};

const reducer: Reducer<HallFloorState> = (state = initialState, action) => {
  switch (action.type) {
    case HallFloorActionTypes.FETCH_FLOORS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case HallFloorActionTypes.FETCH_FLOORS_SUCCESS:
      return {
        ...state,
        loading: false,
        floors: action.payload,
      };
    case HallFloorActionTypes.FETCH_FLOORS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case HallFloorActionTypes.FETCH_FLOOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case HallFloorActionTypes.FETCH_FLOOR_SUCCESS:
      return {
        ...state,
        loading: false,
        floor: action.payload,
      };
    case HallFloorActionTypes.FETCH_FLOOR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case HallFloorActionTypes.CREATE_FLOOR_REQUEST:
      return {
        ...state,
        isHallSubmitting: true,
        success: false,
        failure: false,
        error: null,
      };
    case HallFloorActionTypes.CREATE_FLOOR_SUCCESS:
      return {
        ...state,
        isHallSubmitting: false,
        success: true,
        failure: false,
        floors: [...state.floors, action.payload],
      };
    case HallFloorActionTypes.CREATE_FLOOR_ERROR:
      return {
        ...state,
        isHallSubmitting: false,
        success: false,
        failure: true,
        error: action.payload,
      };
    case HallFloorActionTypes.UPDATE_FLOOR_REQUEST:
      return {
        ...state,
        isHallSubmitting: true,
        success: false,
        failure: false,
        error: null,
      };
    case HallFloorActionTypes.UPDATE_FLOOR_SUCCESS:
      return {
        ...state,
        isHallSubmitting: false,
        success: true,
        failure: false,
        floors: state.floors.map((floor) =>
          floor.id === action.payload.id ? action.payload : floor
        ),
      };
    case HallFloorActionTypes.UPDATE_FLOOR_ERROR:
      return {
        ...state,
        isHallSubmitting: false,
        success: false,
        failure: true,
        error: action.payload,
      };
    case HallFloorActionTypes.DELETE_FLOOR_REQUEST:
      return {
        ...state,
        isHallDeleting: true,
        deleteSuccess: false,
        error: null,
      };
    case HallFloorActionTypes.DELETE_FLOOR_SUCCESS:
      return {
        ...state,
        isHallDeleting: false,
        deleteSuccess: true,
        floors: state.floors.filter((floor) => floor.id !== action.payload),
      };
    case HallFloorActionTypes.DELETE_FLOOR_ERROR:
      return {
        ...state,
        isHallDeleting: false,
        deleteSuccess: false,
        error: action.payload,
      };
    case HallFloorActionTypes.CLEAR_FLOOR_STATE:
      return {
        ...state,
        loading: false,
        error: null,
        isHallFloorSubmitting: false,
        isHallFloorDeleting: false,
        success: false,
        failure: false,
        deleteSuccess: false,
        page: "",
        floors: [],
        rooms: [],
        isRoomSubmitting: false,
        isRoomDeleting: false,
        hall: null,
        floor: null,
        room: null,
      };
    default:
      return state;
  }
};

export { reducer as HallFloorReducer };
